import classes from './Forbidden.module.css'
import {SignOut} from "../";
import { LNG } from '../../Services/LanguageService';

export const Forbidden = () => {
    return (
        <div className={classes.root}>
            <SignOut isDark={true} fixed={true}/>
            <div className={classes.header}>{LNG.Text('scannerApp.3')}</div>
            <p>{LNG.Text('scannerApp.4')}</p>
        </div>
    )
}
